import { render, staticRenderFns } from "./TeacherPermissionsCard.vue?vue&type=template&id=397df40d&"
import script from "./TeacherPermissionsCard.vue?vue&type=script&lang=js&"
export * from "./TeacherPermissionsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports